export default "__VITE_ASSET__CWeBFf6q__"